<template>
  <el-dialog width="1200px" title="Credit Historical Approval Records" :close-on-click-modal="false" :visible.sync="visible" top="3vh">
    <div class="tableWrap">
      <el-table border :data="dataList" v-loading="dataListLoading">
        <el-table-column align="center" label="Handling Time" width="164px">
          <template slot-scope="scope">
            {{ scope.row.createAt | parseTimeSecond }}
          </template>
        </el-table-column>
        <el-table-column align="center" label="Applyment Status" width="154px">
          <template slot-scope="scope">
            {{ creditStatusFormat(scope.row.creditStatus) }}
          </template>
        </el-table-column>
        <el-table-column prop="remark" align="center" label="Reason" />
        <el-table-column align="center" label="Attachment">
          <template slot-scope="scope">
            <p v-for="item in scope.row.attachmentUrls" :key="item.url">
              <a :href="item.url" target="_target">{{ item.name }}</a>
            </p>
          </template>
        </el-table-column>
        <el-table-column align="center" label="Handler">
          <template slot-scope="scope">
            <p v-if="scope.row.userInfo && scope.row.userInfo.nickname">
              {{ scope.row.userInfo.nickname }}
            </p>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页 -->
      <pagination
        :current="current"
        :pageSize="pageSize"
        :totalCount="totalCount"
        @size-change="sizeChangeHandle"
        @current-change="currentChangeHandle"
      ></pagination>
    </div>
  </el-dialog>
</template>

<script>
import Pagination from "@/components/Pagination";
import paginationMixin from "@/mixins/paginationMixin.js";
import filtersMixin from "@/mixins/filtersMixin";
import formatterMixin from "@/mixins/formatterMixin";
export default {
  mixins: [paginationMixin, formatterMixin, filtersMixin],
  components: { Pagination },
  props: {
    orderId: {
      type: String,
    },
  },
  data() {
    return {
      visible: false,
      dataList: [],
      dataListLoading: false,
    };
  },
  methods: {
    // 初始化
    async init() {
      this.visible = true;
      await this.$nextTick();
      this.getDataList(1);
    },
    // 获取分页
    getDataList(current) {
      setTimeout(async () => {
        this.dataListLoading = true;
        if (current) {
          this.current = current;
        }
        const { code, data } = await this.$http.get("/admin/customerOrderCreditLog/paging", {
          params: {
            current: this.current,
            size: this.pageSize,
            "orders[0].asc": false,
            "orders[0].column": "id",
            orderId: this.orderId,
          },
        });
        if (code === 200) {
          this.dataList = data.records;
          this.totalCount = data.total;
        } else {
          this.dataList = [];
          this.totalCount = 0;
        }
        this.dataListLoading = false;
      }, 0);
    },
  },
};
</script>

<style lang="scss" scoped>
.tableWrap {
  padding-bottom: 20px;

  ::v-deep {
    .hide-expend {
      .el-table__expand-icon {
        display: none !important;
      }
    }
  }

  .shrink {
    width: 96%;
    margin: 0 auto;

    ::v-deep {
      th {
        border-right: none;
      }

      tr {
        td {
          border-right: none;
        }
      }
    }
  }

  .shrink::before {
    height: 0;
  }
}
</style>
